import React from 'react';
import { Box, Typography } from '@mui/material';
import PracticeSelector from './PracticeSelector';

export default function OrganizationWorkspaceHeader({ title, showSelector = true }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', mb: 2, flexWrap: 'wrap', gap: 2 }}>
      <Typography variant="h4" component="h1" sx={{ lineHeight: 1.2 }}>
        {title}
      </Typography>
      {showSelector && (
        <Box sx={{ minWidth: 200, maxWidth: 480, display: 'flex', alignItems: 'flex-end' }}>
          <PracticeSelector centered={false} />
        </Box>
      )}
    </Box>
  );
}
